import gql from 'graphql-tag'

// NOTE: be careful when replacing `gql` with `questionnaireGql` since this can break `recordAudienceChangedForIRSNotification` work. Double check if the `recordAudienceChangedForIRSNotification` is still working after the replacement.
export const REMOVE_AUDIENCE_MEMBER_V2 = gql`
  mutation removeAudienceMemberV2($input: RemoveAudienceMemberV2Input!) {
    recordAudienceChangedForIRSNotification @client(always: true)
    removeAudienceMemberV2(input: $input)
  }
`
